import { useEffect, useCallback } from 'react';

interface AuthEventDetail {
  user: {
    id: string;
    email: string;
    name: string;
    token: string;
    role: string;
  };
}

export const useAuthEvent = (callback: (user: AuthEventDetail['user']) => void) => {
  const handleAuthEvent = useCallback((event: CustomEvent<AuthEventDetail>) => {
    callback(event.detail.user);
  }, [callback]);

  useEffect(() => {
    window.addEventListener('userAuthenticated', handleAuthEvent as EventListener);
    
    return () => {
      window.removeEventListener('userAuthenticated', handleAuthEvent as EventListener);
    };
  }, [handleAuthEvent]);
};
